import { FC, KeyboardEvent } from "react";
import { Icon } from "../Icon/Icon";
import { colors } from "../../styles/colors";

type props = {
  isActive?: boolean;
  /**
   * When provided the toggle becomes interactive (role="switch") and calls back
   * with the NEXT value. When omitted the component stays purely presentational,
   * preserving its original behaviour.
   */
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
};

export const CustomToggle: FC<props> = ({
  isActive,
  onChange,
  disabled,
  ariaLabel,
}) => {
  const interactive = typeof onChange === "function" && !disabled;

  const handleToggle = () => {
    if (!interactive) return;
    onChange!(!isActive);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (!interactive) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange!(!isActive);
    }
  };

  return (
    <span
      role={onChange ? "switch" : undefined}
      aria-checked={onChange ? !!isActive : undefined}
      aria-label={ariaLabel}
      aria-disabled={disabled || undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: interactive ? "pointer" : "default",
        opacity: disabled ? 0.5 : 1,
        lineHeight: 0,
      }}
    >
      {isActive ? (
        <Icon
          name="toggleRight"
          width={"24px"}
          height={"24px"}
          color={colors.primary}
        />
      ) : (
        <Icon
          name="toggleLeft"
          width={"24px"}
          height={"24px"}
          color={colors.greydark}
        />
      )}
    </span>
  );
};
